<template>
  <div class="l-item">
    <div class="t-serial t-sans"><p>{{event.date}}</p><p>{{event.time}}</p></div>
    <img :src="event.image" @click="single()">
    <h1 class="t-serif">{{event.title}}</h1>
    <div class="author"><h2 class="t-sans">{{event.location}}</h2></div>
    <p class="t-serif t-project">{{event.description}}</p>
    <h2 class="t-sans">Line Up</h2>
    <div class="l-acts t-sans">
      <span v-for="act in event.lineUp" :key="act.id">{{act}}</span>
    </div>
    <template v-if='event.available'>
      <a :href='event.url' target="blank"><div class="m-btn-buy t-sans">{{stock}}</div></a>
    </template>
  </div>
</template>

<script>
import SafetyNotice from '@/components/SafetyNotice'

export default {
  name: 'event',
  props: ['event'],
  components: {
    SafetyNotice
  },
  data: function () {
    return {
      stock: this.event.stockMessage + ' | £' + this.event.price
    }
  },
  methods: {
    single () {
      this.$router.push({ name: 'EventSingle', params: { single: this.event.id } })
    }
  }
}
</script>

<style scoped lang='scss'>

img {
  transition: filter 0.4s;
  cursor: pointer;
  &:hover {
    filter: blur(4px);
  }
}

.l-acts {
  padding: 0px 60px 40px;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;

  span {
    font-size: 1rem;
    line-height: 1.8rem;
    margin: 5px 5px;
    padding: 6px 12px;
    white-space: nowrap;
    text-align: center;
    border: 1px solid #000;
    color: #000;
    border-radius: 40px;
  }
}

.l-item {
    position: relative;
    max-width: 500px;
}

.l-images {
  width: 500px;
  background:red;
}

h1 {
  text-transform: uppercase;
  font-weight: normal;
}

h2 {
  font-size: 0.8rem;
  border-radius: 20px;
  background: #000;
  color: #fff;
  display: table;
  padding: 8px 12px;
  margin: 0px auto 20px;
}

.author {
  text-align: center;
  h2 {
    display: inline;
    background: #fff;
    border: 1px solid #000;
    color: #000;
    border-radius: 20px;
    padding: 8px 12px;
    font-size: 90%;
  }
}

.t-project {
  padding-top: 20px;
}

.t-serial {
  text-align: center;
  font-size: 1.2rem;
  position: sticky;
  top: 18px;
  p {
    opacity: 0.9;
    background: rgba(74, 255, 100, 0.9);
    color: #000;
    font-size: 0.75rem;
    display: inline;
    border-radius: 20px;
    margin: 0px 5px;
    padding: 5px 10px;
    box-shadow: 0px 0px 10px #f2f2f2;
  }
}

form {
  position: sticky;
  bottom: 0px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 50%);
  height: 50px;
}

.m-btn-out {
  cursor: not-allowed !important;
  &:hover {
    background: #f2f2f2 !important;
  }
}

.m-btn-more {
  color: #fff;
  cursor: pointer;
  border-radius: 60px;
  background: rgba(0,0,0,0.9);
  position: sticky;
  bottom: 60px;
  width: 25px;
  height: 25px;
  text-align:center;
  display: table;
  margin: 0 auto;
  font-size: 1.2rem;
  line-height: 1.5rem;
  transition: background 0.3s, color 0.3s;
  span {

  }

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #000;
    }
  }

  &:hover {
    color: #000;
    background: #4aff64;
  }
}

.m-btn-buy {
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid #fff;
  background: rgba(0,0,0,0.9);
  position: sticky;
  text-align:center;
  bottom: 20px;
  padding: 8px 15px;
  display: table;
  margin: 0 auto;
  font-size: 0.8rem;
  transition: background 0.3s, color 0.3s;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #000;
    }
  }

  span {
    margin: 0px 5px 0px 2px;
  }

  &:hover {
    color: #000;
    background: #4aff64;
  }
}

@media all and (max-width: 600px) {
  .l-item {
    max-width: none;
    border-bottom: 1px solid #000;
  }

  .m-btn-buy {
    margin: 40px auto;
  }
  .track-list {
    padding-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Event.vue